import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ProjectService } from "../../services/project/project.service";
import { FeatureService } from "../../services/feature/feature.service";
import { Project } from "../../interfaces/project";
import { Feature } from "../../interfaces/feature";
import { ActivatedRoute } from "@angular/router";
import { Epic } from "../../interfaces/epic";
import { EpicService } from "../../services/epic/epic.service";
import { JiraService } from "../../services/jira/jira.service";
import { environment } from "../../../environments/environment";
import {
  MzModalService,
  MzModalComponent,
  MzBaseModal,
  MzToastService,
} from "ng2-materialize";
import { ItemCarouselComponent } from "../item-carousel/item-carousel.component";
import { ConfirmSyncComponent } from "../confirm-sync/confirm-sync.component";
import { Subject } from "rxjs";
import { Observable } from "rxjs/Observable";
import { DeleteItemConfirmationDialogComponent } from "../delete-item-confirmation-dialog/delete-item-confirmation-dialog.component";
import { Utils } from "../../utils/utils";
import { EditItemDialogComponent } from "../edit-item-dialog/edit-item-dialog.component";
import { EditThemeDialogComponent } from "../edit-theme-dialog/edit-theme-dialog.component";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";
import { Annotation } from "../../interfaces/annotation";
import { AnnotationService } from "../../services/annotation/annotation.service";
import { AnnotationtypeService } from "../../services/annotationtype/annotationtype.service";
import { Annotationvariant } from "../../interfaces/annotationvariant";
import { AnnotationvariantService } from "../../services/annotationvariant/annotationvariant.service";
import { ExportService } from "../../services/export/export.service";
import { saveAs } from "file-saver";
import { chartColorScheme } from "../../utils/chartColortScheme";

@Component({
  selector: "app-annotation-canvas",
  templateUrl: "./annotation-canvas.component.html",
  styleUrls: ["./annotation-canvas.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnotationCanvasComponent implements OnInit {
  readonly env: any = environment;
  readonly utils: any = Utils;

  // options for average chart
  averageValue: any[]; //kommt raus

  bars: any[] = [];
  lines: any[] = [];

  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegendBar = false;
  showLegendCombo = true;
  showXAxisLabel = true;
  xAxisLabelBar = "Annotationen";
  showYAxisLabel = true;
  yAxisLabelBar = "Nutzen Mittelwert";
  colorScheme = chartColorScheme;
  legendTitle = "Legende";
  legendPosition = "bottom";

  showRightYAxisLabel: boolean = true;
  yAxisLabelRight: string = "Streuung";

  yMin = 0;
  yMax = 10;

  schemeType = "ordinal";

  showBars: boolean = true;
  checkboxes: boolean[] = [false, false, false, false]; //defines wich spread checkboxes are selected by default
  checkboxesDisabled: boolean[] = [false, false, false, false];
  radio: number = 1; // 1 = average; 2 = median
  m = 0; //slope of trendline
  b = 0; // beginning of trendline

  chartWidth = "100%";

  barColor = {
    group: "ordinal",
    domain: ["#d6e098"],
  };
  lineColors = {
    group: "ordinal",
    domain: ["#d6e098", "#90535d", "#686a6e", "#497c88"],
  };

  hasEstimatedItems = false;

  // readonly sortableOptions = {
  //   onUpdate: async (event: any) => {
  //     for (let i = 0; i < this.features.length; i++) {
  //       this.features[i].index = i;
  //     }
  //     await this.saveFeature(this.features[event.newIndex]);
  //     await this.reloadProject();
  //   },
  //   onMove: (evt: any, originalEvent: any) => {
  //     /**
  //      * if y-coordinate of event is <=200, scroll to top of page
  //      */
  //     if (originalEvent.clientY.valueOf() <= 200) {
  //       $('html, body').animate({
  //         scrollTop: 0
  //       }, 'slow');
  //     }
  //   },
  //   ghostClass: 'ghost',
  //   animation: 150,
  //   scroll: true
  // };

  @ViewChild("DeleteItemConfirmationModal")
  DeleteItemConfirmationModal: DeleteItemConfirmationDialogComponent;
  @ViewChild("ItemCarousel") ItemCarousel: ItemCarouselComponent;
  @ViewChild("EditItemModal") EditItemModal: EditItemDialogComponent;
  @ViewChild("EditThemeModal") EditThemeModal: EditThemeDialogComponent;

  carouselItemIndex: number = -1;
  fragmentNr: number = -1;
  loading: boolean;
  project: Project;
  annotations: Array<Annotation>;
  annotationvariants: Array<Annotationvariant>;
  annotationtypes: Object;
  epics: Array<Epic>;

  newFeature = {} as Feature;
  newEpic = { color: Utils.presetThemeColors[0][0] } as Epic;
  editEpicTitle: string;
  epicFilterName = "Nach Themes filtern" as string;
  selectedThemes: Array<String> = [];

  agreementAverage: number = 0;
  agreementMedian: number = 0;
  agreementValues: number[] = [];

  constructor(
    private projectService: ProjectService,
    private annotationtypeService: AnnotationtypeService,
    public modalService: MzModalService,
    private changeDetectorRef: ChangeDetectorRef,
    private planningPokerService: PlanningPokerService,
    private toastService: MzToastService,
    private annotationvariantService: AnnotationvariantService,
    private annotationService: AnnotationService,
    private epicService: EpicService,
    private route: ActivatedRoute,
    private jiraService: JiraService,
    private exportService: ExportService
  ) {}

  ngOnInit() {
    /**
     * get all epics and feature by given projectID
     */
    this.route.params.subscribe(async (params: { id: string }) => {
      await this.loadData(params.id);
      this.changeDetectorRef.detectChanges();
      await this.planningPokerService.watchProject(params.id);
      if (this.planningPokerService.planningOpen) {
        var currentlyEstimatedFeature = this.annotationvariants.filter(
          (x) => x._id === this.planningPokerService.currentFeatureId
        );
        if (currentlyEstimatedFeature.length > 0)
          currentlyEstimatedFeature[0].isBeingEstimated = true;
      }
      this.planningPokerService.estimationStarted.subscribe(
        (estimatedFeature) => {
          var currentlyEstimatedFeature = this.annotationvariants.filter(
            (x) => x._id === estimatedFeature._id
          );
          if (currentlyEstimatedFeature.length > 0)
            currentlyEstimatedFeature[0].isBeingEstimated = true;
        }
      );
      this.planningPokerService.estimationStopped.subscribe((_) => {
        this.annotationvariants.forEach((x) => (x.isBeingEstimated = false));
      });
      this.changeDetectorRef.detectChanges();
    });
    this.route.fragment.subscribe(async (fragment) => {
      if (!isNaN(parseInt(fragment))) {
        this.fragmentNr = parseInt(fragment);
        if (this.annotations != undefined) {
          if (
            this.fragmentNr > -1 &&
            this.fragmentNr - 1 < this.annotations.length
          ) {
            let annotationIndexOnCarousel = 0;
            this.annotations.forEach((annotation) => {
              if (annotation.number < this.fragmentNr) {
                annotationIndexOnCarousel += annotation.variants.length;
              }
            });
            this.carouselItemIndex = annotationIndexOnCarousel;
          }
        }
      }
    });
  }

  async loadData(projectId: string) {
    this.loading = true;
    this.project = await this.projectService.getProjectByShortId(projectId);
    await this.annotationService
      .getAnnotationsByProjectId(this.project._id)
      .then((annotations: Array<Annotation>) => {
        this.annotations = this.getSortedArray(annotations);
        this.annotationvariants = this.flattenAnnotationVariants(
          this.annotations
        );
        this.annotationvariants.forEach((variant) => {
          if (
            variant.estimations.length > 0 &&
            variant.estimations[variant.estimations.length - 1].average &&
            variant.estimations[variant.estimations.length - 1].median
          ) {
            this.hasEstimatedItems = true;
            if (
              variant.estimations[variant.estimations.length - 1].average >
                10 ||
              variant.estimations[variant.estimations.length - 1].median > 10
            ) {
              this.yMax = 100;
              return;
            }
          }
        });
        // this.calcAgreement();
        // this.calcRegression();
        // this.createChartDataObjects(this.annotations);
      });
    await this.annotationtypeService
      .getAnnotationtypesByVersion(this.project.version)
      .then((annotationtypes) => {
        this.annotationtypes = annotationtypes;
      });
    this.project.projectBenefit = this.annotationvariants
      .filter((x) => x.estimations.length > 0)
      .map((x) => x.estimations[x.estimations.length - 1].median)
      .reduce((x, y) => x + y, 0);
    this.showBars =
      this.project.showBars.annotations !== undefined
        ? this.project.showBars.annotations
        : this.showBars;
    this.checkboxes =
      this.project.spreadCheckboxes.annotations || this.checkboxes;
    this.radio = this.project.radio.annotations || this.radio;
    this.calcAgreement();
    this.calcRegression();
    this.createChartDataObjects(this.annotations);
    this.loading = false;
    this.changeDetectorRef.detectChanges();
    if (this.fragmentNr > -1 && this.fragmentNr - 1 < this.annotations.length) {
      let annotationIndexOnCarousel = 0;
      this.annotations.forEach((annotation) => {
        if (annotation.number < this.fragmentNr) {
          annotationIndexOnCarousel += annotation.variants.length;
        }
      });
      this.carouselItemIndex = annotationIndexOnCarousel;
    }
  }

  private getSortedArray(annotations) {
    return annotations.sort(
      (a: any, b: any) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );
  }

  async reloadProject() {
    await this.loadData(this.project.shortId);
  }

  flattenAnnotationVariants(
    annotations: Array<Annotation>
  ): Array<Annotationvariant> {
    return this.annotations.reduce((acc, annotation) => {
      return acc.concat(annotation.variants);
    }, []);
  }

  /**
   * creates new feature with related projectID
   */
  // async createItemClicked(newFeature) {
  //   let createdFeature = await this.featureService.createFeature(newFeature);
  //   this.features.push(createdFeature);
  //   await this.reloadProject();
  //   this.changeDetectorRef.detectChanges();
  // }

  /**
   * creates new feature with related projectID
   */
  // async createThemeClicked(newTheme) {
  //   if (newTheme._id === undefined) {
  //     let createdTheme = await this.epicService.createEpic(newTheme);
  //     this.epics.push(createdTheme);
  //   } else {
  //     await this.epicService.saveEpic(newTheme);
  //   }
  //   await this.reloadProject();
  // }

  /**
   * creates new epic with related projectID
   */
  // async createEpic(newEpic) {
  // 	try {
  //     console.log(newEpic._id);
  //     let epic = await this.epicService.createEpic(newEpic);
  //     this.epics.push(epic);
  //     this.newEpic = {color: Utils.presetThemeColors[0][0]} as Epic;
  //   } catch (error) {
  //     this.newEpic = {color: Utils.presetThemeColors[0][0]} as Epic;
  //   };
  //   await this.reloadProject();
  // }

  fillEpicFilters(epics) {
    for (let i = 0; i < epics.length; i++) {
      epics[i].checked = false;
    }
  }

  /**
   * saves feature
   * @param feature
   */
  // async saveFeature(feature) {
  //   await this.featureService.saveFeature(feature);
  // }

  /**
   * select theme to edit or to delete
   * @param theme
   */
  selectThemeToEdit(theme) {
    this.newEpic = JSON.parse(JSON.stringify(theme));
    this.editEpicTitle = theme.name;
    // this.EpicModal.open();
    setTimeout(Materialize.updateTextFields, 10);
  }

  /**
   * returns all filtered epics as Array
   * @returns {Array}
   */
  // getFilteredEpics() {
  //   let filteredEpics = [];
  //   for (let i = 0; i < this.epics.length; i++) {
  //     if (this.epics[i].filtered) {
  //       filteredEpics.push(this.epics[i]);
  //     }
  //   }
  //   return filteredEpics;
  // }

  /**
   * changes filtered status of given theme and fits the filter name
   * @param epic
   */
  // filterEpic(epic) {
  //   epic.filtered = !epic.filtered;
  //   this.epicFilterName = '';
  //   const filteredEpics = this.getFilteredEpics();
  //   for (let i = 0; i < filteredEpics.length; i++) {
  //     if (i > 0) {
  //       this.epicFilterName += ', ';
  //     }
  //     this.epicFilterName += filteredEpics[i].name;
  //   }
  //   if (this.epicFilterName.length === 0) {
  //     this.epicFilterName = 'Nach Themes filtern';
  //   }
  // }

  /**
   * deletes actual selected theme
   * @param theme
   */
  async deleteTheme() {
    this.loading = true;
    await this.epicService.deleteEpicById(this.newEpic._id);
    await this.loadData(this.project.shortId);
  }

  /**
   * updates a given theme
   * @param theme
   */
  async saveTheme(theme) {
    this.loading = true;
    await this.epicService.saveEpic(theme);
    await this.loadData(this.project.shortId);
  }

  deleteAnnotation(annotation: Annotation) {
    this.loading = true;
    this.annotationService
      .deleteAnnotationById(annotation._id)
      .then(() => {
        this.loadData(this.project.shortId);
        this.loading = false;
        this.changeDetectorRef.detectChanges();
      })
      .catch((error) => {
        this.loading = false;
        this.changeDetectorRef.detectChanges();
      });
  }

  deleteVariant(variant: Annotationvariant) {
    this.annotationvariantService
      .deleteAnnotationvariantById(variant._id)
      .then(() => {
        this.loadData(this.project.shortId);
        this.loading = false;
        this.changeDetectorRef.detectChanges();
      })
      .catch((error) => {
        this.loading = false;
        this.changeDetectorRef.detectChanges();
      });
  }

  async annotationDeleteClicked(variant: Annotationvariant) {
    let result = await this.DeleteItemConfirmationModal.getResultAsync();
    if (result === true) {
      this.loading = true;
      // await this.featureService.deleteFeatureById(feature._id);
      // await this.loadData(this.project.shortId);
      for (let i = 0; i < this.annotations.length; i++) {
        let tempAnnotation = this.annotations[i];
        for (let j = 0; j < tempAnnotation.variants.length; j++) {
          if (tempAnnotation.variants[j]._id === variant._id) {
            if (tempAnnotation.variants.length === 1) {
              this.deleteAnnotation(tempAnnotation);
            } else {
              this.deleteVariant(variant);
            }
            break;
          }
        }
      }
    }
    this.loading = false;
  }

  getRunningIndex(i, j) {
    return (
      this.annotations
        .filter((x, n) => n < i)
        .map((x) => x.variants.length)
        .reduce((a, b) => a + b, 0) + j
    );
  }

  createAnnotation() {
    this.loading = true;
    this.annotationService
      .createAnnotation({ projectId: this.project._id })
      .then((annotation: Annotation) => {
        // this.createVariant(annotation);
        this.annotations.push(annotation);

        this.changeDetectorRef.detectChanges();

        this.carouselItemIndex =
          this.flattenAnnotationVariants(this.annotations).length - 1;
        this.loadData(this.project.shortId);
        this.loading = false;
        this.changeDetectorRef.detectChanges();
      });
  }

  // createVariant(annotation) {
  //   this.loading = true;
  //   const lastVariant = annotation.variants[annotation.variants.length - 1];
  //   this.annotationvariantService.createAnnotationvariant({
  //     projectId: this.project._id,
  //     annotationId: annotation._id,
  //     stakeholder: lastVariant.stakeholder,
  //     description: 'testbeschreibung' //lastVariant.description
  //   }).then((variant: Annotationvariant) => {
  //     this.loading = false;
  //     annotation.variants.push(variant);
  //     $('html, body').animate({scrollTop: $(document).height()}, 'slow');
  //   }).catch(error => {
  //     this.loading = false;
  //   });
  // }

  // async itemDeleteClicked(feature: Feature) {
  //   var result = await this.DeleteItemConfirmationModal.getResultAsync();
  //   if (result === true) {
  //     this.loading = true;
  //     await this.featureService.deleteFeatureById(feature._id);
  //     await this.loadData(this.project.shortId);
  //   }
  // }

  // deleteItemsByThemeId(themeId) {
  //   this.loading = true;
  //   this.featureService.deleteItemsByEpicId(themeId).then(() => {
  //     this.deleteTheme();
  //   });
  // }

  // async carouselDeleteItemClicked(feature: Feature) {
  //   var oldIndex = this.carouselItemIndex;
  //   this.carouselItemIndex = -1;
  //   var result = await this.DeleteItemConfirmationModal.getResultAsync();
  //   if (result === true) {
  //     this.loading = true;
  //     await this.featureService.deleteFeatureById(feature._id);
  //     await this.loadData(this.project.shortId);
  //   }
  //   else
  //     this.carouselItemIndex = oldIndex;
  // }

  showAnnotationDetails(i) {
    this.carouselItemIndex = i;
  }

  async carouselClosed() {
    this.carouselItemIndex = -1;
    this.fragmentNr = -1;
    await this.reloadProject();
  }

  /**
   * adds or removes the themeId to an array of all the selected Themes depending if it is already in the array.
   * Only the Items with an EpicId in this array are shown.
   * If the array is empty all items are shown.
   * @param themeId is the Id of the Theme that has been checked or unchecked.
   */
  selectTheme(themeId) {
    const index = this.selectedThemes.indexOf(themeId);
    if (index === -1) {
      this.selectedThemes.push(themeId);
    } else {
      this.selectedThemes.splice(index, 1);
    }
  }

  /**
   * returns number of estimated items
   * @returns {number}
   */
  // getEstimatedItemCount() {
  //   let count = 0;
  //   for (let i = 0; i < this.features.length; i++) {
  //     if (this.features[i].effort) {
  //       count++;
  //     }
  //   }
  //   return count;
  // }

  openNewItemDialog() {
    this.EditItemModal.modalComponent.open();
  }

  openNewThemeDialog() {
    this.EditThemeModal.modalComponent.open();
  }

  async editTheme(theme) {
    if (await this.EditThemeModal.getEditResultAsync(theme))
      this.epics = this.epics.slice();
  }

  async syncProject() {
    let result = await (<ConfirmSyncComponent>(
      this.modalService.open(ConfirmSyncComponent).instance
    )).result
      .asObservable()
      .first()
      .toPromise();
    if (result) {
      this.loading = true;
      // await this.jiraService.syncProject(this.project.shortId);
      await this.loadData(this.project.shortId);
      this.toastService.show(
        "Projekt wurde erfolgreich synchronisiert.",
        4000,
        "confirm-toast"
      );
      this.changeDetectorRef.detectChanges();
    }
  }

  async exportClicked() {
    var blob = await this.exportService.exportAnnotations(this.project._id);
    saveAs(
      blob,
      this.project.name.replace(/[\\/:"*?<>|]+/, "") + " Annotationen.xlsx"
    );
  }

  /*
  Generates the Dataobjects for the combo chart
  */
  createChartDataObjects(annotations: Array<Annotation>) {
    this.bars = [];
    this.lines = [];

    if (annotations.length > 0) {
      var tempAgreementValue = [];
      var tempAgreementAverageValue = [];
      var tempAgreementMedianValue = [];
      var tempTrendValue = [];
      var countItems = 0;
      annotations.forEach((annotation, i) => {
        if (annotation.variants.length > 0) {
          annotation.variants.forEach((annotationvariant, index) => {
            if (
              annotationvariant.estimations.length > 0 &&
              annotationvariant.estimations[
                annotationvariant.estimations.length - 1
              ].average &&
              annotationvariant.estimations[
                annotationvariant.estimations.length - 1
              ].median
            ) {
              countItems++;
              if (this.showBars) {
                var tempBarValue = {
                  name:
                    annotation.variants.length > 1
                      ? "#" + annotation.number + " V" + (index + 1)
                      : "#" + annotation.number,
                  value:
                    this.radio === 1
                      ? annotationvariant.estimations[
                          annotationvariant.estimations.length - 1
                        ].average
                      : annotationvariant.estimations[
                          annotationvariant.estimations.length - 1
                        ].median,
                };
                this.bars.push(tempBarValue);
              } else {
                var tempBarValue = {
                  name:
                    annotation.variants.length > 1
                      ? "#" + annotation.number + " V" + (index + 1)
                      : "#" + annotation.number,
                  value: 0,
                };
                this.bars.push(tempBarValue);
              }

              if (this.checkboxes[0]) {
                var tempLineSeriesValue = {
                  name:
                    annotation.variants.length > 1
                      ? "#" + annotation.number + " V" + (index + 1)
                      : "#" + annotation.number,
                  value:
                    annotationvariant.estimations[
                      annotationvariant.estimations.length - 1
                    ].agreement,
                };
                tempAgreementValue.push(tempLineSeriesValue);
              }
              if (this.checkboxes[1]) {
                var tempLineSeriesValue = {
                  name:
                    annotation.variants.length > 1
                      ? "#" + annotation.number + " V" + (index + 1)
                      : "#" + annotation.number,
                  value: this.agreementAverage,
                };
                tempAgreementAverageValue.push(tempLineSeriesValue);
              }
              if (this.checkboxes[2]) {
                var tempLineSeriesValue = {
                  name:
                    annotation.variants.length > 1
                      ? "#" + annotation.number + " V" + (index + 1)
                      : "#" + annotation.number,
                  value: this.agreementMedian,
                };
                tempAgreementMedianValue.push(tempLineSeriesValue);
              }
              if (this.checkboxes[3]) {
                var tempLineSeriesValue = {
                  name:
                    annotation.variants.length > 1
                      ? "#" + annotation.number + " V" + (index + 1)
                      : "#" + annotation.number,
                  value: this.m * (tempTrendValue.length + 1) + this.b,
                };
                // console.log("m= " + this.m);
                // console.log("b= " + this.b);
                // console.log("x= " + (tempTrendValue.length + 1));
                // console.log(tempLineSeriesValue);

                tempTrendValue.push(tempLineSeriesValue);
              }
            }
          });
        }
      });
      if (countItems > 39) {
        this.chartWidth = countItems * 30 + 500 + "px";
      } else {
        this.chartWidth = "inherit";
      }

      if (tempAgreementValue.length > 0) {
        this.lines.push({
          name: "Streuung",
          series: tempAgreementValue,
        });
      }
      if (tempAgreementAverageValue.length > 0) {
        this.lines.push({
          name: "Streuung Mittelwert",
          series: tempAgreementAverageValue,
        });
      }
      if (tempAgreementMedianValue.length > 0) {
        this.lines.push({
          name: "Streuung Median",
          series: tempAgreementMedianValue,
        });
      }
      if (tempTrendValue.length > 0) {
        this.lines.push({
          name: "Streuung Trend",
          series: tempTrendValue,
        });
      }
    }
    window.dispatchEvent(new Event("resize"));
  }
  /**
   * calculates the median and average from agreements
   */
  calcAgreement() {
    this.agreementAverage = 0;
    this.agreementValues = [];
    if (this.annotationvariants.length > 0) {
      this.annotationvariants.forEach((variant) => {
        if (variant.estimations.length > 0) {
          //&& variant.estimations[variant.estimations.length - 1].agreement
          this.agreementValues.push(
            variant.estimations[variant.estimations.length - 1].agreement || 0.0
          );
          this.agreementAverage +=
            variant.estimations[variant.estimations.length - 1].agreement ||
            0.0;
        }
      });
      if (this.agreementAverage > 0) {
        this.agreementAverage /= this.agreementValues.length;

        if (this.agreementValues.length % 2 === 1) {
          this.agreementMedian = this.agreementValues[
            Math.ceil(this.agreementValues.length / 2) - 1
          ];
        } else {
          this.agreementMedian =
            (this.agreementValues[this.agreementValues.length / 2 - 1] +
              this.agreementValues[this.agreementValues.length / 2]) /
            2;
        }
      }
    }
  }

  /**
   * calculates the trendline for agreement
   */
  calcRegression() {
    this.m = 0;
    this.b = 0;
    var annotationAverage = 0;
    if (this.agreementValues.length > 0) {
      this.agreementValues.forEach((value, index) => {
        annotationAverage += index + 1;
      });
      annotationAverage /= this.agreementValues.length;
    }
    var sumA = 0;
    var sumB = 0;
    if (this.agreementValues.length > 0) {
      this.agreementValues.forEach((value, index) => {
        sumA +=
          (index + 1 - annotationAverage) * (value - this.agreementAverage);
        sumB += Math.pow(index + 1 - annotationAverage, 2);
      });
      this.m = sumA / sumB;
      this.b = this.agreementAverage - this.m * annotationAverage;
    }
  }

  radioChanged() {
    this.project.radio.annotations = this.radio;
    // this.projectService.updateProject(this.project);
    this.yAxisLabelBar =
      this.radio === 1 ? "Nutzen Mittelwert" : "Nutzen Median";
    this.createChartDataObjects(this.annotations);
  }

  checkboxChanged() {
    this.project.showBars.annotations = this.showBars;
    this.project.spreadCheckboxes.annotations = this.checkboxes;
    // this.projectService.updateProject(this.project);
    var count = 0;
    this.checkboxes.forEach((value) => {
      if (value === true) {
        count++;
      }
    });
    if (count === 0 && !this.showBars) {
      this.bars = [];
      this.lines = [];
    } else {
      this.createChartDataObjects(this.annotations);
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/annotation-canvas/annotation-canvas.component.ts